import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useContext, useState } from 'react';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../index-6420013c.js';
import Icon, { IconTypes, IconColors } from '../../ui/Icon.js';
import Badge from '../../ui/Badge.js';
import { M as MemberList } from '../../MemberList-5d8a0a9b.js';
import { useChannelSettingsContext } from '../context.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import 'prop-types';
import '../../ui/Button.js';
import '../../ui/IconButton.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../ui/ContextMenu.js';
import 'react-dom';
import '../../ui/SortByRow.js';
import '../../uuid-717930b4.js';
import '../../index-579ca9d7.js';
import '../../utils/message/getOutgoingMessageState.js';
import './UserListItem.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../topics-eb548880.js';
import '../../utils-e0c7329c.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../ui/Modal.js';
import '../../index-a9101009.js';
import '../../MediaQueryContext-d6110905.js';
import '../../ui/UserListItem.js';
import '../../ui/Checkbox.js';
var kFormatter = function kFormatter(num) {
  return Math.abs(num) > 999 ? "".concat((Math.abs(num) / 1000).toFixed(1), "K") : num;
};
var UserPanel = function UserPanel() {
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAccordion = _useState2[0],
    setShowAccordion = _useState2[1];
  var _useChannelSettingsCo = useChannelSettingsContext(),
    channel = _useChannelSettingsCo.channel;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-channel-settings__user-panel"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: ['sendbird-channel-settings__panel-item', 'sendbird-channel-settings__members'].join(' '),
    role: "switch",
    "aria-checked": showAccordion,
    onKeyDown: function onKeyDown() {
      return setShowAccordion(!showAccordion);
    },
    onClick: function onClick() {
      return setShowAccordion(!showAccordion);
    },
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: "sendbird-channel-settings__panel-icon-left",
    type: IconTypes.MEMBERS,
    fillColor: IconColors.PRIMARY,
    height: "24px",
    width: "24px"
  }), /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.SUBTITLE_1,
    color: LabelColors.ONBACKGROUND_1
  }, stringSet.CHANNEL_SETTING__MEMBERS__TITLE, /*#__PURE__*/React__default.createElement(Badge, {
    className: 'sendbird-channel-settings__badge',
    count: kFormatter(channel === null || channel === void 0 ? void 0 : channel.memberCount)
  })), /*#__PURE__*/React__default.createElement(Icon, {
    className: ['sendbird-channel-settings__panel-icon-right', 'sendbird-channel-settings__panel-icon--chevron', showAccordion ? 'sendbird-channel-settings__panel-icon--open' : ''].join(' '),
    type: IconTypes.CHEVRON_RIGHT,
    height: "24px",
    width: "24px"
  })), showAccordion && /*#__PURE__*/React__default.createElement(MemberList, null));
};
export { UserPanel as default };